import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { CoordinateNormalizerService } from './coordinate-normalizer.service';
import { CoordinateParserService } from './coordinate-parser.service';
import { CoordinateDropdownRow, ParsedCoordinatePair } from './models/coordinate-search.model';

@Injectable({ providedIn: 'root' })
export class CoordinateSearchFacade {
  private readonly debounceMs = 200;

  constructor(
    private readonly parser: CoordinateParserService,
    private readonly normalizer: CoordinateNormalizerService
  ) {}

  parseToRow(input: string): CoordinateDropdownRow | null {
    const parsed = this.parser.parse(input);
    return parsed ? this.toRow(parsed) : null;
  }

  coordinateRow$(input$: Observable<string>): Observable<CoordinateDropdownRow | null> {
    return input$.pipe(
      debounceTime(this.debounceMs),
      distinctUntilChanged(),
      map((text) => (text.trim() ? this.parseToRow(text) : null)),
      distinctUntilChanged(rowsEqual)
    );
  }

  private toRow(parsed: ParsedCoordinatePair): CoordinateDropdownRow {
    return {
      type: 'coordinate',
      displayLabel: this.normalizer.formatDisplay(parsed),
      lat: parsed.lat,
      lng: parsed.lng,
      rawInput: parsed.rawInput,
      sourceFormat: parsed.sourceFormat,
    };
  }
}

function rowsEqual(
  a: CoordinateDropdownRow | null,
  b: CoordinateDropdownRow | null
): boolean {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.lat === b.lat && a.lng === b.lng && a.displayLabel === b.displayLabel;
}
